import createImmutableSelector from 'lib/immutable/selector'
import { IPages } from './../models'

const getPages = (state: any): IPages => state.get('pagesReducer')

export const pagesSelector = createImmutableSelector(getPages, (pages) => pages)
